import { render, staticRenderFns } from "./DialogDetail.vue?vue&type=template&id=f611ad70&scoped=true"
import script from "./DialogDetail.vue?vue&type=script&lang=js"
export * from "./DialogDetail.vue?vue&type=script&lang=js"
import style0 from "./DialogDetail.vue?vue&type=style&index=0&id=f611ad70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f611ad70",
  null
  
)

export default component.exports